var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumSirDeClame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 78,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3253 32.2727V41H18.7443V33.8111H18.6932L16.652 35.1151V33.6662L18.821 32.2727H20.3253Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 1,
    width: 37,
    height: 78,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7756 41V39.858L56.8054 36.8878C57.0952 36.5952 57.3366 36.3352 57.5298 36.108C57.723 35.8807 57.8679 35.6605 57.9645 35.4474C58.0611 35.2344 58.1094 35.0071 58.1094 34.7656C58.1094 34.4901 58.0469 34.2543 57.9219 34.0582C57.7969 33.8594 57.625 33.706 57.4062 33.598C57.1875 33.4901 56.9389 33.4361 56.6605 33.4361C56.3736 33.4361 56.1222 33.4957 55.9062 33.6151C55.6903 33.7315 55.5227 33.8977 55.4034 34.1136C55.2869 34.3295 55.2287 34.5866 55.2287 34.8849H53.7244C53.7244 34.331 53.8509 33.8494 54.1037 33.4403C54.3565 33.0312 54.7045 32.7145 55.1477 32.4901C55.5938 32.2656 56.1051 32.1534 56.6818 32.1534C57.267 32.1534 57.7813 32.2628 58.2244 32.4815C58.6676 32.7003 59.0114 33 59.2557 33.3807C59.5028 33.7614 59.6264 34.196 59.6264 34.6847C59.6264 35.0114 59.5639 35.3324 59.4389 35.6477C59.3139 35.9631 59.0938 36.3125 58.7784 36.696C58.4659 37.0795 58.027 37.544 57.4616 38.0895L55.9574 39.6193V39.679H59.7585V41H53.7756Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumSirDeClame1);
export default __webpack_public_path__ + "static/media/jum_sir_de_clame_1.8b63d4d172967b1e55b756cec611e396.svg";
export { ForwardRef as ReactComponent };